import React, { Component } from "react";
import { Container, Card, CardHeader, CardText , Spinner } from 'reactstrap';
import PropTypes from 'prop-types';
import user from './Imagenes/user.png';
import url from "./variables/url.js";
import Popout from './Popout';
import { AppContext } from '../AppContext';

const xml2js = require('xml2js');
const APP_ID = process.env.REACT_APP_ID;
const casF = url.CAS_FOTO;
const foto = url.foto;

class UserCards extends Component {
    constructor(props) {
        super(props);
        const {

        } = props.UserCards || {};
        this.state = {
            data: [],
            loading: true,
            cedula: this.props.cedula,
            nombres: this.props.nombres,
            apellidos: this.props.apellidos,
            foto: "",
            matricula: "",
            showPopout: false,
            iduser: 0,
        };
    }
    

    uppercase = word => {
        return word.charAt(0).toUpperCase() + word.slice(1);
    };

    loadData = () => {
        const currentUser = this.context;
        /*console.log(currentUser);*/
        if (currentUser != null) {
            this.state.apellidos = currentUser.apellidos;
            this.state.nombres = currentUser.nombres;
            this.state.cedula = currentUser.identificacion;
            this.state.matricula = currentUser.matricula;
            this.state.foto = currentUser.foto;
            this.state.loading = false;            
        }
    };    

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps, prevState) {
        const currentUser = this.context;
        if (currentUser != null && this.state.iduser == 0) {
            this.setState({ iduser: currentUser.idpersona });
            this.loadData();
        }
    }

    renderInfoUser() {
        return (
            <Container fluid>
                <div className="animated fadeIn" key={this.state.cedula}>
                    <div className="card-body">
                        <div className="avatar">
                            <img
                                src={`${this.state.foto}`}
                                onError={(e) => (e.target.onerror = null, e.target.src = user)}
                                alt=""
                            />
                        </div>
                        <p className="card-text text-center" style={{ fontSize: "1vw" }}>
                            {this.uppercase(this.state.nombres)} <br />
                            {this.uppercase(this.state.apellidos)} <br />
                            {this.state.cedula}
                        </p>

                    </div>
                </div>
            </Container>
        );        
    }

    setPopoutOpen(open) {
        this.setState({
            showPopout: open
        });
    }

    loadImage(matricula) {

        let bodyXml = `<?xml version="1.0" encoding="utf-8"?>
                        <soap:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
                          <soap:Body>
                            <downloadFoto xmlns="http://academico.espol.edu.ec/webservices/">
                              <name>${matricula}</name>
                            </downloadFoto>
                          </soap:Body>
                        </soap:Envelope>`;

        fetch('https://ws.espol.edu.ec/saac/wsMedia.asmx', {
            method: 'POST', headers: { 'Content-Type': 'text/xml' }, body: bodyXml 
        })
            .then(response => response.text())
            .then((result) => {
                xml2js.parseStringPromise(result)
                    .then((data) => {                        
                        this.setState({foto: data['downloadFotoResult']});
                        /*console.log(this.state.foto);*/
                    }
                        )
            });
    }
    

    // When this component is unloaded, make sure we close the popout
    componentDidMount() {
        window.addEventListener('beforeunload', () => {
            this.setPopoutOpen(false);
        });
    }

    // This returns the HTML for the popout, or null if the popout isn't visible
    getPopout() {
        if (!this.state.showPopout) {
            return null;
        }

        return (
            <Popout title='Foto Estudiante' fetch={casF + APP_ID} closeWindow={() => this.setPopoutOpen(true)}>
                <Spinner animation="grow" />
            </Popout>
        );
    }

    render() {

        let contenido = this.state.loading ? <></> : this.renderInfoUser();

        return (
        <div>
                {contenido}                              
        </div>
        );
    }
}

UserCards.propTypes = {
    /*actividades: PropTypes.array.isRequired,*/    
    cedula: PropTypes.string.isRequired,
    nombre: PropTypes.string,
    apellido: PropTypes.string,
    user: PropTypes.string.isRequired
};

UserCards.contextType = AppContext;
export default UserCards;